<template>
  <div class="modal d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Załączniki — rekord #{{ projectFile.id }}
          </h5>

          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="uploadFile">
            <div class="mb-3">
              <label class="form-label">
                Wybierz plik (maksymalnie 10 MB)
              </label>

              <input ref="fileInput" type="file" class="form-control" required />
            </div>

            <button type="submit" class="btn btn-primary" :disabled="loading">
              {{ loading ? 'Przesyłanie...' : 'Dodaj plik' }}
            </button>
          </form>

          <hr />

          <h6>Dodane pliki</h6>

          <div v-if="!files.length" class="text-muted">
            Brak załączników.
          </div>

          <ul v-else class="list-group">
            <li v-for="file in files" :key="file.id"
              class="list-group-item d-flex justify-content-between align-items-center">
              <a :href="route('projects.project-file.files.show', {
                file: file.id
              })" target="_blank">
                {{ file.original_name }}
              </a>

              <button type="button" class="btn btn-sm btn-outline-danger" :disabled="loading" @click="deleteFile(file)">
                Usuń
              </button>
            </li>
          </ul>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import route from '../../../../../vendor/tightenco/ziggy/src/js/index.js';
import axios from 'axios';

export default {
  props: {
    projectFile: {
      type: Object,
      required: true
    }
  },

  emits: [
    'close',
    'refresh',
    'added-success',
    'added-error'
  ],

  data() {
    return {
      files: this.projectFile.files
        ? [...this.projectFile.files]
        : [],
      loading: false
    };
  },

  watch: {
    projectFile: {
      immediate: true,
      handler(value) {
        this.files = value.files
          ? [...value.files]
          : [];
      }
    }
  },

  methods: {
    route,

    async loadFiles() {
      const response = await axios.get(
        route('projects.project-file.files.index', {
          projectFile: this.projectFile.id
        })
      );

      this.files = [...response.data.files];

      // Powiadom rodzica, żeby zaktualizował wiersz
      this.$emit('refresh');
    },

    async uploadFile() {
      const selectedFile = this.$refs.fileInput.files[0];

      if (!selectedFile) {
        return;
      }

      const formData = new FormData();
      formData.append('file', selectedFile);

      this.loading = true;

      try {
        await axios.post(
          route('projects.project-file.files.store', {
            projectFile: this.projectFile.id
          }),
          formData
        );

        await this.loadFiles();

        this.$refs.fileInput.value = '';

        this.$emit('added-success', 'Załącznik dodany!');
      } catch (error) {
        this.$emit(
          'added-error',
          error.response?.data?.message ||
          'Nie udało się dodać załącznika.'
        );
      } finally {
        this.loading = false;
      }
    },

    async deleteFile(file) {
      if (!confirm(`Czy usunąć plik "${file.original_name}"?`)) {
        return;
      }

      this.loading = true;

      try {
        await axios.delete(
          route('projects.project-file.files.destroy', {
            projectFile: this.projectFile.id,
            file: file.id
          })
        );

        await this.loadFiles();

        this.$emit('added-success', 'Załącznik usunięty!');
      } catch (error) {
        this.$emit(
          'added-error',
          error.response?.data?.message ||
          'Nie udało się usunąć załącznika.'
        );
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
